import React from 'react'
import styled from 'styled-components'
import { DropdownCopytradingTopTradersItem } from '../../../../DropdownCopytradingTopTradersItem'
import { DropdownCopytradingTopTradersLoader } from '../../../../DropdownCopytradingTopTradersLoader'
import { DROPDOWN_COPYTRADING_TRADERS_BACKGROUND_URL } from '../constants'
import { DropdownCopytradingTopTradersListProps } from './types'

export const DropdownCopytradingTopTradersList = (props: DropdownCopytradingTopTradersListProps) => {
  const { traders, isLoading } = props

  if (isLoading) {
    return (
      <TradersContainer>
        {Array.from({ length: 3 }).map((_, index) => (
          <DropdownCopytradingTopTradersLoader key={index} />
        ))}
      </TradersContainer>
    )
  }

  return (
    <TradersContainer>
      {traders.slice(0, 3).map((trader, index) => {
        return (
          <DropdownCopytradingTopTradersItem
            key={trader.id}
            account={trader}
            backgroundUrl={DROPDOWN_COPYTRADING_TRADERS_BACKGROUND_URL[index]}
          />
        )
      })}
    </TradersContainer>
  )
}

const TradersContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 0 16px;
`
